module.exports = ":host .product-image {\n  border-radius: 2px;\n  padding: 2px;\n  -ms-flex-line-pack: center;\n      align-content: center;\n  vertical-align: central; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/product/product.component.scss
// module id = ./src/app/shared/product/product.component.scss
// module chunks = main